import { LitElement, html, css } from 'lit';
import '../../Time/Timestamp';
import '../../ReadMark/SingleMark/SingleMark.js';
import '../../ReadMark/BlueReadMark/BlueReadMark.js';
import '../../ReadMark/DoubleMark/DoubleMark.js';
import '../../ReadMark/ClockMark/ClockMark.js';
import '../../EmojiReactions/EmojiReactions.js';
import '../../Popup/ConfirmationPopup/DeleteConfirmationPopup/DeletePopup.js';
import '../../../../components/ChatUIComponent/ReactionContainer.js';
import'../../ForwardMessage/ForwardUi.js'
export class AudioBubbleUI extends LitElement {
  static get properties() {
    return {
      isPlaying: { type: Boolean },
      audioDuration: { type: String },
      isSelf: { type: Boolean },
      isDelivered: { type: Boolean },
      isRead: { type: Boolean },
      showFooter: { type: Boolean },
      textColor: { type: String },
      timeColor: { type: String },
      time: { type: String },
      bgColor: { type: String },
      borderRadius: { type: String },
      playAudioHandler: { type: Function },
      pauseAudioHandler: { type: Function },
      messageId: { type: String },
      reactions: { type: Object },
      showConfirmationPopup: { type: Boolean },
      selectedEmojiToRemove: { type: Object },
      showAllReactionsPopup: {type: Boolean},
      showReactionButton: {type: Boolean},
      showEmojiReactions: {type: Boolean},
      messageType: { type: Number },
      showReactionOnHover: {type: Boolean}
    };
  }

  static get styles() {
    return css`
      :host {
        display: block;
      }

        reaction-container {
      display: block;
       min-height: 150px;
       max-height: fit-content;
       min-width: 300px;
       max-width: 400px;
       position: absolute;
       z-index: 100;
    }
      .audio-bubble-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        padding: 10px 10px 20px 10px;
        margin: 0.25rem 0px 0.25rem auto;
        border-radius: 7.5px;
        width: 336px;
        box-sizing: border-box;
      }

      .sender-bg {
        background-color: var(--bg-outgoing-message);
      }

      .receiver-bg {
        background-color: var(--bg-incoming-message);
      }
      .sender-text {
        color: var(--text-outgoing-message);
      }

      .receiver-text {
        color: var(--text-incoming-message);
      }

      .sender-icon svg {
        stroke: var(--text-outgoing-message);
      }

      .receiver-icon svg {
        stroke: var(--text-incoming-message);
      }

      .audio-content {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 10px;
      }

      .wavesurfer-timeline-progress {
        width: 10px !important;
        height: 10px !important;
        border-radius: 50% !important;
        background-color: red !important;
      }

      .user_profile_picture {
        width: 55px;
        height: 55px;
        object-fit: cover;
        border-radius: 50%;
      }

      @media (max-width: 768px) {
        .audio-bubble-wrapper {
          width: 280px;
        }
      }

      .chat_audio_play_pause {
        width: 24px;
        height: 24px;
        min-width: 24px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .wave_container {
        flex: 1;
        height: 40px;
        min-height: 40px;
        border-radius: 4px;
      }

      .audio-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        font-size: 10px;
        margin-top: 4px;
      }

      .audio-time {
        font-size: 10px;
      }

      .userContact_image {
        width: 55px;
        height: 55px;
        border-radius: 50%;
        background-color: #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: bold;
      }

      .pointer {
        cursor: pointer;
      }

      .message-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 4px;
        width: 100%;
        margin-top: auto;
        font-size: 12px;
      }

        .emoji-slider {
      position: absolute;
    }

    emoji-reactions {
      position: absolute;
      top: 15px;
      z-index: 99;
      left: 0;
    }

    .reaction-button {
      position: absolute;
      top: 50%;
      right: -25px;
      transform: translateY(-50%);
      cursor: pointer;
      z-index: 100;
    }

      .remaining-count {
      background-color: var(--bg-primary-light);
      font-size: 14px;
      display: flex;
      justify-content: center;
      color: var(--text-primary-color);
      width: 25px;
      cursor: pointer;
    }

    .reactions-display {
      position: absolute;
      bottom: -10px;
      right: 10px;
      display: grid;
      grid-template-columns: repeat(3, auto);
      gap: 0;
      margin-top: 4px;
      background-color: transparent;
    }

    .reaction-item {
      display: flex;
      align-items: center;
      gap: 2px;
      border-radius: 12px;
      background: var(--bg-secondary-color);
      font-size: 20px;
      cursor: pointer;
    }
    `;
  }

  constructor() {
    super();
    this.isPlaying = false;
    this.audioDuration = '0:00';
    this.isSelf = false;
    this.showReactionButton = false;
    this.showEmojiReactions = false;
    this.reactions = {};
    this.showAllReactionsPopup = false;
    this.showReactionOnHover = true
  }

  firstUpdated() {
    // Ensure everything is rendered first
    setTimeout(() => {
      const waveContainer = this.shadowRoot.querySelector('.wave_container');
      if (waveContainer) {
        // Make sure the component is fully rendered and attached to DOM
        this.dispatchEvent(
          new CustomEvent('waveformReady', {
            detail: waveContainer,
            bubbles: true,
            composed: true,
          }),
        );
      } else {
        console.error('Wave container element not found in shadowRoot');
      }
    }, 50);
  }

  handleMouseEnter() {
    if(this.showReactionOnHover) {
    this.showReactionButton = true;
    }
  }

 
  handleReactionRemove(reaction) {
    this.showEmojiReactions = false;

    this.showConfirmationPopup = true;
    this.selectedEmojiToRemove = reaction;
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
    }, 100)
  }

  handleMouseLeave(e) {
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const reactionButton = this.renderRoot.querySelector('.reaction-button');

    const isEmojiSliderOpen = this.showEmojiReactions;

    const isMovingToMessage = messageContainer?.contains(e.relatedTarget);
    const isMovingToEmoji = emojiReactions && emojiReactions?.contains(e.relatedTarget);
    const isMovingToReactionButton = reactionButton && reactionButton?.contains(e.relatedTarget);

    if (!isMovingToMessage && !isMovingToEmoji && !isMovingToReactionButton) {
      this.showReactionButton = false;
      
      if (!isEmojiSliderOpen) {
        this.showEmojiReactions = false;
      }
    }
  }

 handleOutsideClick = (e) => {
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const reactionContainer = this.renderRoot.querySelector('reaction-container');
    
    const path = e.composedPath();
    
    if ((this.showEmojiReactions &&
      !path.includes(emojiReactions) &&
      !path.includes(messageContainer)) ||
      (this.showConfirmationPopup &&
      !path.includes(reactionContainer) &&
      !path.includes(messageContainer))
    ) {
      this.showEmojiReactions = false;
      this.showConfirmationPopup = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }
    toggleEmojiReactions() {
    this.showConfirmationPopup = false;

    this.showEmojiReactions = !this.showEmojiReactions;
    
    if (this.showEmojiReactions) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 100);
    }
  }
  handleEmojiClick(emoji) {
    const currentUserId = this.userMetaData?.userId;
    const usersForEmoji = this.reactions[emoji.id] || [];
    const hasReaction = usersForEmoji.includes(currentUserId);
  
    let existingReactionEmojiId = null;
  
    for (const [emojiId, userIds] of Object.entries(this.reactions)) {
      if (userIds.includes(currentUserId)) {
        existingReactionEmojiId = emojiId;
        break;
      }
    }
  
    if (existingReactionEmojiId && existingReactionEmojiId !== emoji.id) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: existingReactionEmojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    if (hasReaction) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    } else {
      this.dispatchEvent(
        new CustomEvent('reaction-added', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    this.showEmojiReactions = false;
    document.removeEventListener('click', this.handleOutsideClick);
  }
  handleConfirmRemove() {
    if (this.selectedEmojiToRemove) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: this.selectedEmojiToRemove.emojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.closeConfirmationPopup();
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
  }



  render() {
    const wrapperClass = `audio-bubble-wrapper ${this.isSelf ? 'sender-bg' : 'receiver-bg'}`;
    const textClass = this.isSelf ? 'sender-text' : 'receiver-text';
    
    const emojiList = document.createElement('emoji-reactions').emojis;
    const allReactions = Object.keys(this.reactions)
      .map(reaction => {
        const matchingEmoji = emojiList.find(emoji => emoji.id === reaction);
        return {
          emojiId: reaction,
          messageId: this.reactions[reaction],
          src: matchingEmoji?.src,
        };
      })
      .filter(reaction => Array.isArray(reaction.messageId) && reaction.messageId.length > 0); 
    
    const visibleReactions = allReactions.slice(0, 2);
    const remainingCount = allReactions.length > 2 ? allReactions.length - 2 : 0;

    return html`
      <div class=${wrapperClass}  @mouseover="${() => this.handleMouseEnter()}"
        @mouseout="${e => this.handleMouseLeave(e)}">
          ${this.messageType === 1
          ? html`
              ${this.messageType === 1
          ? html`
              <forward-ui></forward-ui>
            `
          : null}
            `
          : null}
        <div class="audio-content">
          ${this._renderPlayPauseIcon()}
          <div class="wave_container" id="waveform-container"></div>
        </div>
          ${!this.isSelf && this.showReactionButton
          ? html`
        <div class="reaction-button" @click="${() => this.toggleEmojiReactions()}"  ">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--text-primary-color)">
            <path d="M612-516q25 0 42.5-17.5T672-576q0-25-17.5-42.5T612-636q-25 0-42.5 17.5T552-576q0 25 17.5 42.5T612-516Zm-264 0q25 0 42.5-17.5T408-576q0-25-17.5-42.5T348-636q-25 0-42.5 17.5T288-576q0 25 17.5 42.5T348-516Zm132 228q60 0 110.5-31t79.5-84H290q29 53 79.5 84T480-288Zm.28 192Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30ZM480-480Zm0 312q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Z"/>
          </svg>
        </div>
      `
          : ''}

          ${this.showConfirmationPopup
          ? html` <reaction-container .messageId=${this.messageId} .userMetaData=${this.userMetaData} .reactions=${allReactions}></reaction-container> `
          : ''}
        ${this.showEmojiReactions
          ? html`
              <emoji-reactions .isOpen="${this.showEmojiReactions}" .onEmojiSelect="${emoji => this.handleEmojiClick(emoji)}" .selectedEmojis="${this.reactions}"></emoji-reactions>
            `
          : ''}

        <div class="reactions-display">
          ${visibleReactions?.map(
            reaction => html`
              <span class="reaction-item" @click="${() => this.handleReactionRemove(reaction)}"> ${reaction.src ? html`<span>${reaction.src}</span>` : ''} </span>
            `,
          )}
         ${remainingCount > 0
            ? html`
                <span  @click="${() => this.handleReactionRemove(visibleReactions[0])}" class="reaction-item remaining-count" "> +${remainingCount} </span>
              
              `
            : ''}
        </div>
        <div class="audio-info">
          <span class="audio-time ${textClass}">${this.audioDuration}</span>
        </div>
        
        ${this.showFooter ? html`
        <div class="message-footer">
          <timestamp-element time="${this.time || new Date().toISOString()}" color="${this.timeColor}"  ></timestamp-element>
          ${this.isSelf
            ? this.isRead
              ? html`<blue-read-mark></blue-read-mark>`
              : this.isDelivered === 'true'
              ? html`<double-mark></double-mark>`
              : this.isDelivered === 'pending'
              ? html`<clock-mark></clock-mark>`
              : html`<single-mark></single-mark>`
            : ''}
        </div>`:null}
      </div>
    `;
  }

  _renderPlayPauseIcon() {
    const iconClass = `chat_audio_play_pause pointer ${this.isSelf ? 'sender-icon' : 'receiver-icon'}`;
    if (this.isPlaying) {
      return html`
        <div @click=${this.pauseAudioHandler} class=${iconClass}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="6" y="4" width="4" height="16"></rect>
            <rect x="14" y="4" width="4" height="16"></rect>
          </svg>
        </div>
      `;
    } else {
      return html`
        <div @click=${this.playAudioHandler} class=${iconClass}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polygon points="5 3 19 12 5 21 5 3"></polygon>
          </svg>
        </div>
      `;
    }
  }
}

customElements.define('audio-bubble-ui', AudioBubbleUI);